// Картинка питання — на основному екрані компактна (max-h ~30vh), щоб варіанти
// помістилися без свайпу. По тапу — відкривається повноекранний overlay для деталей.
import { useState, useEffect } from 'react';

export function ZoomableImage({ src, alt = '' }: { src: string; alt?: string }) {
  const [open, setOpen] = useState(false);

  // Esc для закриття overlay
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="group relative block w-full"
        aria-label="Збільшити зображення"
      >
        <img
          src={src}
          alt={alt}
          className="max-h-[38vh] w-full rounded-lg bg-tg-bg object-contain"
          loading="lazy"
        />
        <span className="pointer-events-none absolute right-2 top-2 rounded-md bg-black/60 px-2 py-1 text-[10px] font-medium text-white opacity-0 transition group-hover:opacity-100">
          🔍 збільшити
        </span>
      </button>

      {open && (
        <div
          onClick={() => setOpen(false)}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 backdrop-blur"
          role="dialog"
        >
          <img
            src={src}
            alt={alt}
            className="max-h-full max-w-full rounded-lg object-contain"
          />
          <button
            onClick={() => setOpen(false)}
            className="absolute right-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-white/15 text-white backdrop-blur transition hover:bg-white/25"
            aria-label="Закрити"
          >
            ✕
          </button>
        </div>
      )}
    </>
  );
}
